/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TaskListRouteImport } from './routes/task-list'
import { Route as SearchRouteImport } from './routes/search'
import { Route as MessagesRouteImport } from './routes/messages'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LiveQueueRouteImport } from './routes/live-queue'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ActionHistoryRouteImport } from './routes/action-history'
import { Route as AccountSettingsRouteImport } from './routes/account-settings'
import { Route as PatientPatientIdRouteImport } from './routes/patient/$patientId'
import { Route as PatientPatientIdWorkNotesRouteImport } from './routes/patient/$patientId/work-notes'
import { Route as PatientPatientIdWomensHealthRouteImport } from './routes/patient/$patientId/womens-health'
import { Route as PatientPatientIdVitalsRouteImport } from './routes/patient/$patientId/vitals'
import { Route as PatientPatientIdTimelineRouteImport } from './routes/patient/$patientId/timeline'
import { Route as PatientPatientIdSurgicalHistoryRouteImport } from './routes/patient/$patientId/surgical-history'
import { Route as PatientPatientIdSocialHistoryRouteImport } from './routes/patient/$patientId/social-history'
import { Route as PatientPatientIdSexualHistoryRouteImport } from './routes/patient/$patientId/sexual-history'
import { Route as PatientPatientIdQuickViewRouteImport } from './routes/patient/$patientId/quick-view'
import { Route as PatientPatientIdProfileRouteImport } from './routes/patient/$patientId/profile'
import { Route as PatientPatientIdMedicationsAllergiesRouteImport } from './routes/patient/$patientId/medications-allergies'
import { Route as PatientPatientIdMedicalHistoryRouteImport } from './routes/patient/$patientId/medical-history'
import { Route as PatientPatientIdLabsRouteImport } from './routes/patient/$patientId/labs'
import { Route as PatientPatientIdImmunizationsRouteImport } from './routes/patient/$patientId/immunizations'
import { Route as PatientPatientIdHospitalizationsRouteImport } from './routes/patient/$patientId/hospitalizations'
import { Route as PatientPatientIdHieDataRouteImport } from './routes/patient/$patientId/hie-data'
import { Route as PatientPatientIdHealthTopicsRouteImport } from './routes/patient/$patientId/health-topics'
import { Route as PatientPatientIdHealthMaintenanceRouteImport } from './routes/patient/$patientId/health-maintenance'
import { Route as PatientPatientIdHealthInsuranceRouteImport } from './routes/patient/$patientId/health-insurance'
import { Route as PatientPatientIdGoalsRouteImport } from './routes/patient/$patientId/goals'
import { Route as PatientPatientIdFilesRouteImport } from './routes/patient/$patientId/files'
import { Route as PatientPatientIdFamilyHistoryRouteImport } from './routes/patient/$patientId/family-history'
import { Route as PatientPatientIdExternalRecordsRouteImport } from './routes/patient/$patientId/external-records'
import { Route as PatientPatientIdExternalCareTeamRouteImport } from './routes/patient/$patientId/external-care-team'
import { Route as PatientPatientIdCareTeamRouteImport } from './routes/patient/$patientId/care-team'
import { Route as PatientPatientIdAlertsRouteImport } from './routes/patient/$patientId/alerts'
import { Route as PatientPatientIdAiFeedRouteImport } from './routes/patient/$patientId/ai-feed'
import { Route as PatientPatientIdFilesFileIdRouteImport } from './routes/patient/$patientId/files/$fileId'

const TaskListRoute = TaskListRouteImport.update({
  id: '/task-list',
  path: '/task-list',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const MessagesRoute = MessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LiveQueueRoute = LiveQueueRouteImport.update({
  id: '/live-queue',
  path: '/live-queue',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const ActionHistoryRoute = ActionHistoryRouteImport.update({
  id: '/action-history',
  path: '/action-history',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountSettingsRoute = AccountSettingsRouteImport.update({
  id: '/account-settings',
  path: '/account-settings',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientPatientIdRoute = PatientPatientIdRouteImport.update({
  id: '/patient/$patientId',
  path: '/patient/$patientId',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientPatientIdWorkNotesRoute =
  PatientPatientIdWorkNotesRouteImport.update({
    id: '/work-notes',
    path: '/work-notes',
    getParentRoute: () => PatientPatientIdRoute,
  } as any)
const PatientPatientIdWomensHealthRoute =
  PatientPatientIdWomensHealthRouteImport.update({
    id: '/womens-health',
    path: '/womens-health',
    getParentRoute: () => PatientPatientIdRoute,
  } as any)
const PatientPatientIdVitalsRoute = PatientPatientIdVitalsRouteImport.update({
  id: '/vitals',
  path: '/vitals',
  getParentRoute: () => PatientPatientIdRoute,
} as any)
const PatientPatientIdTimelineRoute =
  PatientPatientIdTimelineRouteImport.update({
    id: '/timeline',
    path: '/timeline',
    getParentRoute: () => PatientPatientIdRoute,
  } as any)
const PatientPatientIdSurgicalHistoryRoute =
  PatientPatientIdSurgicalHistoryRouteImport.update({
    id: '/surgical-history',
    path: '/surgical-history',
    getParentRoute: () => PatientPatientIdRoute,
  } as any)
const PatientPatientIdSocialHistoryRoute =
  PatientPatientIdSocialHistoryRouteImport.update({
    id: '/social-history',
    path: '/social-history',
    getParentRoute: () => PatientPatientIdRoute,
  } as any)
const PatientPatientIdSexualHistoryRoute =
  PatientPatientIdSexualHistoryRouteImport.update({
    id: '/sexual-history',
    path: '/sexual-history',
    getParentRoute: () => PatientPatientIdRoute,
  } as any)
const PatientPatientIdQuickViewRoute =
  PatientPatientIdQuickViewRouteImport.update({
    id: '/quick-view',
    path: '/quick-view',
    getParentRoute: () => PatientPatientIdRoute,
  } as any)
const PatientPatientIdProfileRoute = PatientPatientIdProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => PatientPatientIdRoute,
} as any)
const PatientPatientIdMedicationsAllergiesRoute =
  PatientPatientIdMedicationsAllergiesRouteImport.update({
    id: '/medications-allergies',
    path: '/medications-allergies',
    getParentRoute: () => PatientPatientIdRoute,
  } as any)
const PatientPatientIdMedicalHistoryRoute =
  PatientPatientIdMedicalHistoryRouteImport.update({
    id: '/medical-history',
    path: '/medical-history',
    getParentRoute: () => PatientPatientIdRoute,
  } as any)
const PatientPatientIdLabsRoute = PatientPatientIdLabsRouteImport.update({
  id: '/labs',
  path: '/labs',
  getParentRoute: () => PatientPatientIdRoute,
} as any)
const PatientPatientIdImmunizationsRoute =
  PatientPatientIdImmunizationsRouteImport.update({
    id: '/immunizations',
    path: '/immunizations',
    getParentRoute: () => PatientPatientIdRoute,
  } as any)
const PatientPatientIdHospitalizationsRoute =
  PatientPatientIdHospitalizationsRouteImport.update({
    id: '/hospitalizations',
    path: '/hospitalizations',
    getParentRoute: () => PatientPatientIdRoute,
  } as any)
const PatientPatientIdHieDataRoute = PatientPatientIdHieDataRouteImport.update({
  id: '/hie-data',
  path: '/hie-data',
  getParentRoute: () => PatientPatientIdRoute,
} as any)
const PatientPatientIdHealthTopicsRoute =
  PatientPatientIdHealthTopicsRouteImport.update({
    id: '/health-topics',
    path: '/health-topics',
    getParentRoute: () => PatientPatientIdRoute,
  } as any)
const PatientPatientIdHealthMaintenanceRoute =
  PatientPatientIdHealthMaintenanceRouteImport.update({
    id: '/health-maintenance',
    path: '/health-maintenance',
    getParentRoute: () => PatientPatientIdRoute,
  } as any)
const PatientPatientIdHealthInsuranceRoute =
  PatientPatientIdHealthInsuranceRouteImport.update({
    id: '/health-insurance',
    path: '/health-insurance',
    getParentRoute: () => PatientPatientIdRoute,
  } as any)
const PatientPatientIdGoalsRoute = PatientPatientIdGoalsRouteImport.update({
  id: '/goals',
  path: '/goals',
  getParentRoute: () => PatientPatientIdRoute,
} as any)
const PatientPatientIdFilesRoute = PatientPatientIdFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => PatientPatientIdRoute,
} as any)
const PatientPatientIdFamilyHistoryRoute =
  PatientPatientIdFamilyHistoryRouteImport.update({
    id: '/family-history',
    path: '/family-history',
    getParentRoute: () => PatientPatientIdRoute,
  } as any)
const PatientPatientIdExternalRecordsRoute =
  PatientPatientIdExternalRecordsRouteImport.update({
    id: '/external-records',
    path: '/external-records',
    getParentRoute: () => PatientPatientIdRoute,
  } as any)
const PatientPatientIdExternalCareTeamRoute =
  PatientPatientIdExternalCareTeamRouteImport.update({
    id: '/external-care-team',
    path: '/external-care-team',
    getParentRoute: () => PatientPatientIdRoute,
  } as any)
const PatientPatientIdCareTeamRoute =
  PatientPatientIdCareTeamRouteImport.update({
    id: '/care-team',
    path: '/care-team',
    getParentRoute: () => PatientPatientIdRoute,
  } as any)
const PatientPatientIdAlertsRoute = PatientPatientIdAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => PatientPatientIdRoute,
} as any)
const PatientPatientIdAiFeedRoute = PatientPatientIdAiFeedRouteImport.update({
  id: '/ai-feed',
  path: '/ai-feed',
  getParentRoute: () => PatientPatientIdRoute,
} as any)
const PatientPatientIdFilesFileIdRoute =
  PatientPatientIdFilesFileIdRouteImport.update({
    id: '/$fileId',
    path: '/$fileId',
    getParentRoute: () => PatientPatientIdFilesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/account-settings': typeof AccountSettingsRoute
  '/action-history': typeof ActionHistoryRoute
  '/admin': typeof AdminRoute
  '/live-queue': typeof LiveQueueRoute
  '/login': typeof LoginRoute
  '/messages': typeof MessagesRoute
  '/search': typeof SearchRoute
  '/task-list': typeof TaskListRoute
  '/patient/$patientId': typeof PatientPatientIdRouteWithChildren
  '/patient/$patientId/ai-feed': typeof PatientPatientIdAiFeedRoute
  '/patient/$patientId/alerts': typeof PatientPatientIdAlertsRoute
  '/patient/$patientId/care-team': typeof PatientPatientIdCareTeamRoute
  '/patient/$patientId/external-care-team': typeof PatientPatientIdExternalCareTeamRoute
  '/patient/$patientId/external-records': typeof PatientPatientIdExternalRecordsRoute
  '/patient/$patientId/family-history': typeof PatientPatientIdFamilyHistoryRoute
  '/patient/$patientId/files': typeof PatientPatientIdFilesRouteWithChildren
  '/patient/$patientId/goals': typeof PatientPatientIdGoalsRoute
  '/patient/$patientId/health-insurance': typeof PatientPatientIdHealthInsuranceRoute
  '/patient/$patientId/health-maintenance': typeof PatientPatientIdHealthMaintenanceRoute
  '/patient/$patientId/health-topics': typeof PatientPatientIdHealthTopicsRoute
  '/patient/$patientId/hie-data': typeof PatientPatientIdHieDataRoute
  '/patient/$patientId/hospitalizations': typeof PatientPatientIdHospitalizationsRoute
  '/patient/$patientId/immunizations': typeof PatientPatientIdImmunizationsRoute
  '/patient/$patientId/labs': typeof PatientPatientIdLabsRoute
  '/patient/$patientId/medical-history': typeof PatientPatientIdMedicalHistoryRoute
  '/patient/$patientId/medications-allergies': typeof PatientPatientIdMedicationsAllergiesRoute
  '/patient/$patientId/profile': typeof PatientPatientIdProfileRoute
  '/patient/$patientId/quick-view': typeof PatientPatientIdQuickViewRoute
  '/patient/$patientId/sexual-history': typeof PatientPatientIdSexualHistoryRoute
  '/patient/$patientId/social-history': typeof PatientPatientIdSocialHistoryRoute
  '/patient/$patientId/surgical-history': typeof PatientPatientIdSurgicalHistoryRoute
  '/patient/$patientId/timeline': typeof PatientPatientIdTimelineRoute
  '/patient/$patientId/vitals': typeof PatientPatientIdVitalsRoute
  '/patient/$patientId/womens-health': typeof PatientPatientIdWomensHealthRoute
  '/patient/$patientId/work-notes': typeof PatientPatientIdWorkNotesRoute
  '/patient/$patientId/files/$fileId': typeof PatientPatientIdFilesFileIdRoute
}
export interface FileRoutesByTo {
  '/account-settings': typeof AccountSettingsRoute
  '/action-history': typeof ActionHistoryRoute
  '/admin': typeof AdminRoute
  '/live-queue': typeof LiveQueueRoute
  '/login': typeof LoginRoute
  '/messages': typeof MessagesRoute
  '/search': typeof SearchRoute
  '/task-list': typeof TaskListRoute
  '/patient/$patientId': typeof PatientPatientIdRouteWithChildren
  '/patient/$patientId/ai-feed': typeof PatientPatientIdAiFeedRoute
  '/patient/$patientId/alerts': typeof PatientPatientIdAlertsRoute
  '/patient/$patientId/care-team': typeof PatientPatientIdCareTeamRoute
  '/patient/$patientId/external-care-team': typeof PatientPatientIdExternalCareTeamRoute
  '/patient/$patientId/external-records': typeof PatientPatientIdExternalRecordsRoute
  '/patient/$patientId/family-history': typeof PatientPatientIdFamilyHistoryRoute
  '/patient/$patientId/files': typeof PatientPatientIdFilesRouteWithChildren
  '/patient/$patientId/goals': typeof PatientPatientIdGoalsRoute
  '/patient/$patientId/health-insurance': typeof PatientPatientIdHealthInsuranceRoute
  '/patient/$patientId/health-maintenance': typeof PatientPatientIdHealthMaintenanceRoute
  '/patient/$patientId/health-topics': typeof PatientPatientIdHealthTopicsRoute
  '/patient/$patientId/hie-data': typeof PatientPatientIdHieDataRoute
  '/patient/$patientId/hospitalizations': typeof PatientPatientIdHospitalizationsRoute
  '/patient/$patientId/immunizations': typeof PatientPatientIdImmunizationsRoute
  '/patient/$patientId/labs': typeof PatientPatientIdLabsRoute
  '/patient/$patientId/medical-history': typeof PatientPatientIdMedicalHistoryRoute
  '/patient/$patientId/medications-allergies': typeof PatientPatientIdMedicationsAllergiesRoute
  '/patient/$patientId/profile': typeof PatientPatientIdProfileRoute
  '/patient/$patientId/quick-view': typeof PatientPatientIdQuickViewRoute
  '/patient/$patientId/sexual-history': typeof PatientPatientIdSexualHistoryRoute
  '/patient/$patientId/social-history': typeof PatientPatientIdSocialHistoryRoute
  '/patient/$patientId/surgical-history': typeof PatientPatientIdSurgicalHistoryRoute
  '/patient/$patientId/timeline': typeof PatientPatientIdTimelineRoute
  '/patient/$patientId/vitals': typeof PatientPatientIdVitalsRoute
  '/patient/$patientId/womens-health': typeof PatientPatientIdWomensHealthRoute
  '/patient/$patientId/work-notes': typeof PatientPatientIdWorkNotesRoute
  '/patient/$patientId/files/$fileId': typeof PatientPatientIdFilesFileIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/account-settings': typeof AccountSettingsRoute
  '/action-history': typeof ActionHistoryRoute
  '/admin': typeof AdminRoute
  '/live-queue': typeof LiveQueueRoute
  '/login': typeof LoginRoute
  '/messages': typeof MessagesRoute
  '/search': typeof SearchRoute
  '/task-list': typeof TaskListRoute
  '/patient/$patientId': typeof PatientPatientIdRouteWithChildren
  '/patient/$patientId/ai-feed': typeof PatientPatientIdAiFeedRoute
  '/patient/$patientId/alerts': typeof PatientPatientIdAlertsRoute
  '/patient/$patientId/care-team': typeof PatientPatientIdCareTeamRoute
  '/patient/$patientId/external-care-team': typeof PatientPatientIdExternalCareTeamRoute
  '/patient/$patientId/external-records': typeof PatientPatientIdExternalRecordsRoute
  '/patient/$patientId/family-history': typeof PatientPatientIdFamilyHistoryRoute
  '/patient/$patientId/files': typeof PatientPatientIdFilesRouteWithChildren
  '/patient/$patientId/goals': typeof PatientPatientIdGoalsRoute
  '/patient/$patientId/health-insurance': typeof PatientPatientIdHealthInsuranceRoute
  '/patient/$patientId/health-maintenance': typeof PatientPatientIdHealthMaintenanceRoute
  '/patient/$patientId/health-topics': typeof PatientPatientIdHealthTopicsRoute
  '/patient/$patientId/hie-data': typeof PatientPatientIdHieDataRoute
  '/patient/$patientId/hospitalizations': typeof PatientPatientIdHospitalizationsRoute
  '/patient/$patientId/immunizations': typeof PatientPatientIdImmunizationsRoute
  '/patient/$patientId/labs': typeof PatientPatientIdLabsRoute
  '/patient/$patientId/medical-history': typeof PatientPatientIdMedicalHistoryRoute
  '/patient/$patientId/medications-allergies': typeof PatientPatientIdMedicationsAllergiesRoute
  '/patient/$patientId/profile': typeof PatientPatientIdProfileRoute
  '/patient/$patientId/quick-view': typeof PatientPatientIdQuickViewRoute
  '/patient/$patientId/sexual-history': typeof PatientPatientIdSexualHistoryRoute
  '/patient/$patientId/social-history': typeof PatientPatientIdSocialHistoryRoute
  '/patient/$patientId/surgical-history': typeof PatientPatientIdSurgicalHistoryRoute
  '/patient/$patientId/timeline': typeof PatientPatientIdTimelineRoute
  '/patient/$patientId/vitals': typeof PatientPatientIdVitalsRoute
  '/patient/$patientId/womens-health': typeof PatientPatientIdWomensHealthRoute
  '/patient/$patientId/work-notes': typeof PatientPatientIdWorkNotesRoute
  '/patient/$patientId/files/$fileId': typeof PatientPatientIdFilesFileIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/account-settings'
    | '/action-history'
    | '/admin'
    | '/live-queue'
    | '/login'
    | '/messages'
    | '/search'
    | '/task-list'
    | '/patient/$patientId'
    | '/patient/$patientId/ai-feed'
    | '/patient/$patientId/alerts'
    | '/patient/$patientId/care-team'
    | '/patient/$patientId/external-care-team'
    | '/patient/$patientId/external-records'
    | '/patient/$patientId/family-history'
    | '/patient/$patientId/files'
    | '/patient/$patientId/goals'
    | '/patient/$patientId/health-insurance'
    | '/patient/$patientId/health-maintenance'
    | '/patient/$patientId/health-topics'
    | '/patient/$patientId/hie-data'
    | '/patient/$patientId/hospitalizations'
    | '/patient/$patientId/immunizations'
    | '/patient/$patientId/labs'
    | '/patient/$patientId/medical-history'
    | '/patient/$patientId/medications-allergies'
    | '/patient/$patientId/profile'
    | '/patient/$patientId/quick-view'
    | '/patient/$patientId/sexual-history'
    | '/patient/$patientId/social-history'
    | '/patient/$patientId/surgical-history'
    | '/patient/$patientId/timeline'
    | '/patient/$patientId/vitals'
    | '/patient/$patientId/womens-health'
    | '/patient/$patientId/work-notes'
    | '/patient/$patientId/files/$fileId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/account-settings'
    | '/action-history'
    | '/admin'
    | '/live-queue'
    | '/login'
    | '/messages'
    | '/search'
    | '/task-list'
    | '/patient/$patientId'
    | '/patient/$patientId/ai-feed'
    | '/patient/$patientId/alerts'
    | '/patient/$patientId/care-team'
    | '/patient/$patientId/external-care-team'
    | '/patient/$patientId/external-records'
    | '/patient/$patientId/family-history'
    | '/patient/$patientId/files'
    | '/patient/$patientId/goals'
    | '/patient/$patientId/health-insurance'
    | '/patient/$patientId/health-maintenance'
    | '/patient/$patientId/health-topics'
    | '/patient/$patientId/hie-data'
    | '/patient/$patientId/hospitalizations'
    | '/patient/$patientId/immunizations'
    | '/patient/$patientId/labs'
    | '/patient/$patientId/medical-history'
    | '/patient/$patientId/medications-allergies'
    | '/patient/$patientId/profile'
    | '/patient/$patientId/quick-view'
    | '/patient/$patientId/sexual-history'
    | '/patient/$patientId/social-history'
    | '/patient/$patientId/surgical-history'
    | '/patient/$patientId/timeline'
    | '/patient/$patientId/vitals'
    | '/patient/$patientId/womens-health'
    | '/patient/$patientId/work-notes'
    | '/patient/$patientId/files/$fileId'
  id:
    | '__root__'
    | '/account-settings'
    | '/action-history'
    | '/admin'
    | '/live-queue'
    | '/login'
    | '/messages'
    | '/search'
    | '/task-list'
    | '/patient/$patientId'
    | '/patient/$patientId/ai-feed'
    | '/patient/$patientId/alerts'
    | '/patient/$patientId/care-team'
    | '/patient/$patientId/external-care-team'
    | '/patient/$patientId/external-records'
    | '/patient/$patientId/family-history'
    | '/patient/$patientId/files'
    | '/patient/$patientId/goals'
    | '/patient/$patientId/health-insurance'
    | '/patient/$patientId/health-maintenance'
    | '/patient/$patientId/health-topics'
    | '/patient/$patientId/hie-data'
    | '/patient/$patientId/hospitalizations'
    | '/patient/$patientId/immunizations'
    | '/patient/$patientId/labs'
    | '/patient/$patientId/medical-history'
    | '/patient/$patientId/medications-allergies'
    | '/patient/$patientId/profile'
    | '/patient/$patientId/quick-view'
    | '/patient/$patientId/sexual-history'
    | '/patient/$patientId/social-history'
    | '/patient/$patientId/surgical-history'
    | '/patient/$patientId/timeline'
    | '/patient/$patientId/vitals'
    | '/patient/$patientId/womens-health'
    | '/patient/$patientId/work-notes'
    | '/patient/$patientId/files/$fileId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AccountSettingsRoute: typeof AccountSettingsRoute
  ActionHistoryRoute: typeof ActionHistoryRoute
  AdminRoute: typeof AdminRoute
  LiveQueueRoute: typeof LiveQueueRoute
  LoginRoute: typeof LoginRoute
  MessagesRoute: typeof MessagesRoute
  SearchRoute: typeof SearchRoute
  TaskListRoute: typeof TaskListRoute
  PatientPatientIdRoute: typeof PatientPatientIdRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/task-list': {
      id: '/task-list'
      path: '/task-list'
      fullPath: '/task-list'
      preLoaderRoute: typeof TaskListRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/messages': {
      id: '/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof MessagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/live-queue': {
      id: '/live-queue'
      path: '/live-queue'
      fullPath: '/live-queue'
      preLoaderRoute: typeof LiveQueueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/action-history': {
      id: '/action-history'
      path: '/action-history'
      fullPath: '/action-history'
      preLoaderRoute: typeof ActionHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account-settings': {
      id: '/account-settings'
      path: '/account-settings'
      fullPath: '/account-settings'
      preLoaderRoute: typeof AccountSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patient/$patientId': {
      id: '/patient/$patientId'
      path: '/patient/$patientId'
      fullPath: '/patient/$patientId'
      preLoaderRoute: typeof PatientPatientIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patient/$patientId/work-notes': {
      id: '/patient/$patientId/work-notes'
      path: '/work-notes'
      fullPath: '/patient/$patientId/work-notes'
      preLoaderRoute: typeof PatientPatientIdWorkNotesRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/womens-health': {
      id: '/patient/$patientId/womens-health'
      path: '/womens-health'
      fullPath: '/patient/$patientId/womens-health'
      preLoaderRoute: typeof PatientPatientIdWomensHealthRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/vitals': {
      id: '/patient/$patientId/vitals'
      path: '/vitals'
      fullPath: '/patient/$patientId/vitals'
      preLoaderRoute: typeof PatientPatientIdVitalsRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/timeline': {
      id: '/patient/$patientId/timeline'
      path: '/timeline'
      fullPath: '/patient/$patientId/timeline'
      preLoaderRoute: typeof PatientPatientIdTimelineRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/surgical-history': {
      id: '/patient/$patientId/surgical-history'
      path: '/surgical-history'
      fullPath: '/patient/$patientId/surgical-history'
      preLoaderRoute: typeof PatientPatientIdSurgicalHistoryRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/social-history': {
      id: '/patient/$patientId/social-history'
      path: '/social-history'
      fullPath: '/patient/$patientId/social-history'
      preLoaderRoute: typeof PatientPatientIdSocialHistoryRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/sexual-history': {
      id: '/patient/$patientId/sexual-history'
      path: '/sexual-history'
      fullPath: '/patient/$patientId/sexual-history'
      preLoaderRoute: typeof PatientPatientIdSexualHistoryRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/quick-view': {
      id: '/patient/$patientId/quick-view'
      path: '/quick-view'
      fullPath: '/patient/$patientId/quick-view'
      preLoaderRoute: typeof PatientPatientIdQuickViewRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/profile': {
      id: '/patient/$patientId/profile'
      path: '/profile'
      fullPath: '/patient/$patientId/profile'
      preLoaderRoute: typeof PatientPatientIdProfileRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/medications-allergies': {
      id: '/patient/$patientId/medications-allergies'
      path: '/medications-allergies'
      fullPath: '/patient/$patientId/medications-allergies'
      preLoaderRoute: typeof PatientPatientIdMedicationsAllergiesRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/medical-history': {
      id: '/patient/$patientId/medical-history'
      path: '/medical-history'
      fullPath: '/patient/$patientId/medical-history'
      preLoaderRoute: typeof PatientPatientIdMedicalHistoryRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/labs': {
      id: '/patient/$patientId/labs'
      path: '/labs'
      fullPath: '/patient/$patientId/labs'
      preLoaderRoute: typeof PatientPatientIdLabsRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/immunizations': {
      id: '/patient/$patientId/immunizations'
      path: '/immunizations'
      fullPath: '/patient/$patientId/immunizations'
      preLoaderRoute: typeof PatientPatientIdImmunizationsRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/hospitalizations': {
      id: '/patient/$patientId/hospitalizations'
      path: '/hospitalizations'
      fullPath: '/patient/$patientId/hospitalizations'
      preLoaderRoute: typeof PatientPatientIdHospitalizationsRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/hie-data': {
      id: '/patient/$patientId/hie-data'
      path: '/hie-data'
      fullPath: '/patient/$patientId/hie-data'
      preLoaderRoute: typeof PatientPatientIdHieDataRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/health-topics': {
      id: '/patient/$patientId/health-topics'
      path: '/health-topics'
      fullPath: '/patient/$patientId/health-topics'
      preLoaderRoute: typeof PatientPatientIdHealthTopicsRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/health-maintenance': {
      id: '/patient/$patientId/health-maintenance'
      path: '/health-maintenance'
      fullPath: '/patient/$patientId/health-maintenance'
      preLoaderRoute: typeof PatientPatientIdHealthMaintenanceRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/health-insurance': {
      id: '/patient/$patientId/health-insurance'
      path: '/health-insurance'
      fullPath: '/patient/$patientId/health-insurance'
      preLoaderRoute: typeof PatientPatientIdHealthInsuranceRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/goals': {
      id: '/patient/$patientId/goals'
      path: '/goals'
      fullPath: '/patient/$patientId/goals'
      preLoaderRoute: typeof PatientPatientIdGoalsRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/files': {
      id: '/patient/$patientId/files'
      path: '/files'
      fullPath: '/patient/$patientId/files'
      preLoaderRoute: typeof PatientPatientIdFilesRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/family-history': {
      id: '/patient/$patientId/family-history'
      path: '/family-history'
      fullPath: '/patient/$patientId/family-history'
      preLoaderRoute: typeof PatientPatientIdFamilyHistoryRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/external-records': {
      id: '/patient/$patientId/external-records'
      path: '/external-records'
      fullPath: '/patient/$patientId/external-records'
      preLoaderRoute: typeof PatientPatientIdExternalRecordsRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/external-care-team': {
      id: '/patient/$patientId/external-care-team'
      path: '/external-care-team'
      fullPath: '/patient/$patientId/external-care-team'
      preLoaderRoute: typeof PatientPatientIdExternalCareTeamRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/care-team': {
      id: '/patient/$patientId/care-team'
      path: '/care-team'
      fullPath: '/patient/$patientId/care-team'
      preLoaderRoute: typeof PatientPatientIdCareTeamRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/alerts': {
      id: '/patient/$patientId/alerts'
      path: '/alerts'
      fullPath: '/patient/$patientId/alerts'
      preLoaderRoute: typeof PatientPatientIdAlertsRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/ai-feed': {
      id: '/patient/$patientId/ai-feed'
      path: '/ai-feed'
      fullPath: '/patient/$patientId/ai-feed'
      preLoaderRoute: typeof PatientPatientIdAiFeedRouteImport
      parentRoute: typeof PatientPatientIdRoute
    }
    '/patient/$patientId/files/$fileId': {
      id: '/patient/$patientId/files/$fileId'
      path: '/$fileId'
      fullPath: '/patient/$patientId/files/$fileId'
      preLoaderRoute: typeof PatientPatientIdFilesFileIdRouteImport
      parentRoute: typeof PatientPatientIdFilesRoute
    }
  }
}

interface PatientPatientIdFilesRouteChildren {
  PatientPatientIdFilesFileIdRoute: typeof PatientPatientIdFilesFileIdRoute
}

const PatientPatientIdFilesRouteChildren: PatientPatientIdFilesRouteChildren = {
  PatientPatientIdFilesFileIdRoute: PatientPatientIdFilesFileIdRoute,
}

const PatientPatientIdFilesRouteWithChildren =
  PatientPatientIdFilesRoute._addFileChildren(
    PatientPatientIdFilesRouteChildren,
  )

interface PatientPatientIdRouteChildren {
  PatientPatientIdAiFeedRoute: typeof PatientPatientIdAiFeedRoute
  PatientPatientIdAlertsRoute: typeof PatientPatientIdAlertsRoute
  PatientPatientIdCareTeamRoute: typeof PatientPatientIdCareTeamRoute
  PatientPatientIdExternalCareTeamRoute: typeof PatientPatientIdExternalCareTeamRoute
  PatientPatientIdExternalRecordsRoute: typeof PatientPatientIdExternalRecordsRoute
  PatientPatientIdFamilyHistoryRoute: typeof PatientPatientIdFamilyHistoryRoute
  PatientPatientIdFilesRoute: typeof PatientPatientIdFilesRouteWithChildren
  PatientPatientIdGoalsRoute: typeof PatientPatientIdGoalsRoute
  PatientPatientIdHealthInsuranceRoute: typeof PatientPatientIdHealthInsuranceRoute
  PatientPatientIdHealthMaintenanceRoute: typeof PatientPatientIdHealthMaintenanceRoute
  PatientPatientIdHealthTopicsRoute: typeof PatientPatientIdHealthTopicsRoute
  PatientPatientIdHieDataRoute: typeof PatientPatientIdHieDataRoute
  PatientPatientIdHospitalizationsRoute: typeof PatientPatientIdHospitalizationsRoute
  PatientPatientIdImmunizationsRoute: typeof PatientPatientIdImmunizationsRoute
  PatientPatientIdLabsRoute: typeof PatientPatientIdLabsRoute
  PatientPatientIdMedicalHistoryRoute: typeof PatientPatientIdMedicalHistoryRoute
  PatientPatientIdMedicationsAllergiesRoute: typeof PatientPatientIdMedicationsAllergiesRoute
  PatientPatientIdProfileRoute: typeof PatientPatientIdProfileRoute
  PatientPatientIdQuickViewRoute: typeof PatientPatientIdQuickViewRoute
  PatientPatientIdSexualHistoryRoute: typeof PatientPatientIdSexualHistoryRoute
  PatientPatientIdSocialHistoryRoute: typeof PatientPatientIdSocialHistoryRoute
  PatientPatientIdSurgicalHistoryRoute: typeof PatientPatientIdSurgicalHistoryRoute
  PatientPatientIdTimelineRoute: typeof PatientPatientIdTimelineRoute
  PatientPatientIdVitalsRoute: typeof PatientPatientIdVitalsRoute
  PatientPatientIdWomensHealthRoute: typeof PatientPatientIdWomensHealthRoute
  PatientPatientIdWorkNotesRoute: typeof PatientPatientIdWorkNotesRoute
}

const PatientPatientIdRouteChildren: PatientPatientIdRouteChildren = {
  PatientPatientIdAiFeedRoute: PatientPatientIdAiFeedRoute,
  PatientPatientIdAlertsRoute: PatientPatientIdAlertsRoute,
  PatientPatientIdCareTeamRoute: PatientPatientIdCareTeamRoute,
  PatientPatientIdExternalCareTeamRoute: PatientPatientIdExternalCareTeamRoute,
  PatientPatientIdExternalRecordsRoute: PatientPatientIdExternalRecordsRoute,
  PatientPatientIdFamilyHistoryRoute: PatientPatientIdFamilyHistoryRoute,
  PatientPatientIdFilesRoute: PatientPatientIdFilesRouteWithChildren,
  PatientPatientIdGoalsRoute: PatientPatientIdGoalsRoute,
  PatientPatientIdHealthInsuranceRoute: PatientPatientIdHealthInsuranceRoute,
  PatientPatientIdHealthMaintenanceRoute:
    PatientPatientIdHealthMaintenanceRoute,
  PatientPatientIdHealthTopicsRoute: PatientPatientIdHealthTopicsRoute,
  PatientPatientIdHieDataRoute: PatientPatientIdHieDataRoute,
  PatientPatientIdHospitalizationsRoute: PatientPatientIdHospitalizationsRoute,
  PatientPatientIdImmunizationsRoute: PatientPatientIdImmunizationsRoute,
  PatientPatientIdLabsRoute: PatientPatientIdLabsRoute,
  PatientPatientIdMedicalHistoryRoute: PatientPatientIdMedicalHistoryRoute,
  PatientPatientIdMedicationsAllergiesRoute:
    PatientPatientIdMedicationsAllergiesRoute,
  PatientPatientIdProfileRoute: PatientPatientIdProfileRoute,
  PatientPatientIdQuickViewRoute: PatientPatientIdQuickViewRoute,
  PatientPatientIdSexualHistoryRoute: PatientPatientIdSexualHistoryRoute,
  PatientPatientIdSocialHistoryRoute: PatientPatientIdSocialHistoryRoute,
  PatientPatientIdSurgicalHistoryRoute: PatientPatientIdSurgicalHistoryRoute,
  PatientPatientIdTimelineRoute: PatientPatientIdTimelineRoute,
  PatientPatientIdVitalsRoute: PatientPatientIdVitalsRoute,
  PatientPatientIdWomensHealthRoute: PatientPatientIdWomensHealthRoute,
  PatientPatientIdWorkNotesRoute: PatientPatientIdWorkNotesRoute,
}

const PatientPatientIdRouteWithChildren =
  PatientPatientIdRoute._addFileChildren(PatientPatientIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AccountSettingsRoute: AccountSettingsRoute,
  ActionHistoryRoute: ActionHistoryRoute,
  AdminRoute: AdminRoute,
  LiveQueueRoute: LiveQueueRoute,
  LoginRoute: LoginRoute,
  MessagesRoute: MessagesRoute,
  SearchRoute: SearchRoute,
  TaskListRoute: TaskListRoute,
  PatientPatientIdRoute: PatientPatientIdRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
